import { render } from "./EmployeeProfilePicture.vue?vue&type=template&id=42073826&scoped=true"
import script from "./EmployeeProfilePicture.vue?vue&type=script&lang=js"
export * from "./EmployeeProfilePicture.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=42073826&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42073826"]])

export default __exports__